import reducer from "./EkgResourcesReducers";

export default reducer;
